export default [
    {// 首页
        path: 'home',
        name: 'home',
        component: () => import('../views/home/home'),
    },
    //监控大屏
    {// 登录后跳转到的页面
        path: 'monitorHome',
        name: 'monitorHome',
        component: () => import('../views/monitor/monitorHome'),
    },
    {// 平台监控大屏
        path: 'monitorPingTai',
        name: 'monitorPingTai',
        component: () => import('../views/monitor/monitorPingTai'),
    },
    {// 运营监控大屏
        path: 'monitorYunYing',
        name: 'monitorYunYing',
        component: () => import('../views/monitor/monitorYunYing'),
    },
    {// 企业监控大屏
        path: 'monitorQiYe',
        name: 'monitorQiYe',
        component: () => import('../views/monitor/monitorQiYe'),
    },
    {// 小程序监控大屏
        path: 'monitorXiaoChengXu',
        name: 'monitorXiaoChengXu',
        component: () => import('../views/monitor/monitorXiaoChengXu'),
    },
    {// APP监控大屏
        path: 'monitorAPP',
        name: 'monitorAPP',
        component: () => import('../views/monitor/monitorApp'),
    },
    //车辆管理-- 车辆管理
    {// 轨迹查询
        path: 'trackQuery',
        name: 'trackQuery',
        component: () => import('../views/car/carMan/trackQuery'),
    },
    {// 轨迹设计
        path: 'trackDesign',
        name: 'trackDesign',
        component: () => import('../views/car/carMan/trackDesign'),
    },
    {// 行驶列表 
        path: 'travelList',
        name: 'travelList',
        component: () => import('../views/car/carMan/travelList'),
    },
    {// 停车列表
        path: 'stopCarList',
        name: 'stopCarList',
        component: () => import('../views/car/carMan/stopCarList'),
    },
    {// 状态查询 
        path: 'stateQuery',
        name: 'stateQuery',
        component: () => import('../views/car/carMan/stateQuery'),
    },
    {// 离线查询
        path: 'offLineQuery',
        name: 'offLineQuery',
        component: () => import('../views/car/carMan/offLineQuery'),
    },
    //车辆管理-- 车载视频
    {// 车辆追踪
        path: 'carVideoTrace',
        name: 'carVideoTrace',
        component: () => import('../views/car/video/carVideoTrace'),
    },
    {// 实时位置/轨迹
        path: 'carVideoLoca',
        name: 'carVideoLoca',
        component: () => import('../views/car/video/carVideoLoca'),
    },
    {// 实时监控
        path: 'carVideoRT',
        name: 'carVideoRT',
        component: () => import('../views/car/video/carVideoRT'),
    },
    {// 历史视频
        path: 'carVideoHistory',
        name: 'carVideoHistory',
        component: () => import('../views/car/video/carVideoHistory'),
    },
    {// 多媒体查询
        path: 'carVideoDuomeiti',
        name: 'carVideoDuomeiti',
        component: () => import('../views/car/video/carVideoDuomeiti'),
    },
    {// 照片查询
        path: 'carVideoPhoto',
        name: 'carVideoPhoto',
        component: () => import('../views/car/video/carVideoPhoto'),
    },
    {// 音频报警查询
        path: 'carVideoBaojing',
        name: 'carVideoBaojing',
        component: () => import('../views/car/video/carVideoBaojing'),
    },
    {// 音频故障查询
        path: 'carVideoFault',
        name: 'carVideoFault',
        component: () => import('../views/car/video/carVideoFault'),
    },
    {// 指令下达
        path: 'carVideoOrder',
        name: 'carVideoOrder',
        component: () => import('../views/car/video/carVideoOrder'),
    },
    //车辆管理-- 主动安全
    {// 实时报警
        path: 'carSafetyAlert',
        name: 'carSafetyAlert',
        component: () => import('../views/car/safety/carSafetyAlert'),
    },
    {// 报警处理
        path: 'carSafetyDispose',
        name: 'carSafetyDispose',
        component: () => import('../views/car/safety/carSafetyDispose'),
    },
    {// 车辆安全分析
        path: 'carSafetyCarFenXi',
        name: 'carSafetyCarFenXi',
        component: () => import('../views/car/safety/carSafetyCarFenXi'),
    },
    {// 驾驶员安全分析
        path: 'carSafetyDriverFenXi',
        name: 'carSafetyDriverFenXi',
        component: () => import('../views/car/safety/carSafetyDriverFenXi'),
    },
    {// 报警设置
        path: 'carSafetySet',
        name: 'carSafetySet',
        component: () => import('../views/car/safety/carSafetySet'),
    },
    //记录查询
    {// 交接班记录
        path: 'recordJiaoBan',
        name: 'recordJiaoBan',
        component: () => import('../views/record/recordJiaoBan'),
    },
    {// 历史指令
        path: 'recordHistory',
        name: 'recordHistory',
        component: () => import('../views/record/recordHistory'),
    },
    {// 调度信息
        path: 'recordDispatch',
        name: 'recordDispatch',
        component: () => import('../views/record/recordDispatch'),
    },
    {// 限时限数
        path: 'recordTimeLimit',
        name: 'recordTimeLimit',
        component: () => import('../views/record/recordTimeLimit'),
    },
    {// 驾驶员变更明细
        path: 'recordDriver',
        name: 'recordDriver',
        component: () => import('../views/record/recordDriver'),
    },
    // 人员管理 -- 车辆人员管理
    {// 考勤管理
        path: 'peopleCarKaoQin',
        name: 'peopleCarKaoQin',
        component: () => import('../views/people/car/peopleCarKaoQin'),
    },
    {// 车辆异常管理
        path: 'peopleCarCar',
        name: 'peopleCarCar',
        component: () => import('../views/people/car/peopleCarCar'),
    },
    {// 排班管理
        path: 'peopleCarPaiBan',
        name: 'peopleCarPaiBan',
        component: () => import('../views/people/car/peopleCarPaiBan'),
    },
    {// 作业区域管理
        path: 'peopleCarQuYu',
        name: 'peopleCarQuYu',
        component: () => import('../views/people/car/peopleCarQuYu'),
    },
    // 人员管理 -- 环卫人员管理
    {// 考勤管理
        path: 'peopleSanitationKaoQin',
        name: 'peopleSanitationKaoQin',
        component: () => import('../views/people/sanitation/peopleSanitationKaoQin'),
    },
    {// 排班管理
        path: 'peopleSanitationPaiBan',
        name: 'peopleSanitationPaiBan',
        component: () => import('../views/people/sanitation/peopleSanitationPaiBan'),
    },
    {// 轨迹管理
        path: 'peopleSanitationGuiJi',
        name: 'peopleSanitationGuiJi',
        component: () => import('../views/people/sanitation/peopleSanitationGuiJi'),
    },
    {// 位置管理
        path: 'peopleSanitationWeiZhi',
        name: 'peopleSanitationWeiZhi',
        component: () => import('../views/people/sanitation/peopleSanitationWeiZhi'),
    },
    {// 作业区域管理
        path: 'peopleSanitationQuYu',
        name: 'peopleSanitationQuYu',
        component: () => import('../views/people/sanitation/peopleSanitationQuYu'),
    },
    // 人员管理 -- 垃圾亭人员管理
    {// 考勤管理
        path: 'peopleGarbageKaoQin',
        name: 'peopleGarbageKaoQin',
        component: () => import('../views/people/garbage/peopleGarbageKaoQin'),
    },
    {// 排班管理
        path: 'peopleGarbagePaiBan',
        name: 'peopleGarbagePaiBan',
        component: () => import('../views/people/garbage/peopleGarbagePaiBan'),
    },
    {// 位置管理
        path: 'peopleGarbageWeiZhi',
        name: 'peopleGarbageWeiZhi',
        component: () => import('../views/people/garbage/peopleGarbageWeiZhi'),
    },
    {// 作业区域管理
        path: 'peopleGarbageQuYu',
        name: 'peopleGarbageQuYu',
        component: () => import('../views/people/garbage/peopleGarbageQuYu'),
    },
    // 人员管理 -- 安全管理
    {// 安全报警
        path: 'peopleSafetyBaoJing',
        name: 'peopleSafetyBaoJing',
        component: () => import('../views/people/safety/peopleSafetyBaoJing'),
    },
    {// 报警处理
        path: 'peopleSafetyChuLi',
        name: 'peopleSafetyChuLi',
        component: () => import('../views/people/safety/peopleSafetyChuLi'),
    },
    {// 报警统计
        path: 'peopleSafetyTongJi',
        name: 'peopleSafetyTongJi',
        component: () => import('../views/people/safety/peopleSafetyTongJi'),
    },
    // 临时增加的四个彩蛋
    {// 商品管理
        path: 'shopmanage',
        name: 'shopmanage',
        component: () => import('../views/rubbishKiosk/shopmanage'),
    }, {// 设备管理
        path: 'deviceDetails',
        name: 'deviceDetails',
        component: () => import('../views/rubbishKiosk/deviceDetails'),
    }, {// 用户列表
        path: 'userList',
        name: 'userList',
        component: () => import('../views/rubbishKiosk/userList'),
    }, {// 积分兑换记录
        path: 'pointExchangeList',
        name: 'pointExchangeList',
        component: () => import('../views/rubbishKiosk/pointExchangeList'),
    },
    {// 重量管理
        path: 'weightManage',
        name: 'weightManage',
        component: () => import('../views/rubbishKiosk/weightManage'),
    },
    //垃圾处理厂
    {// 车辆计重查询
        path: 'refusePlantCarJiZhong',
        name: 'refusePlantCarJiZhong',
        component: () => import('../views/refusePlant/refusePlantCarJiZhong'),
    },
    {// 车辆识别查询
        path: 'refusePlantCarQuery',
        name: 'refusePlantCarQuery',
        component: () => import('../views/refusePlant/refusePlantCarQuery'),
    },
    {// 视频监控
        path: 'refusePlantJianKong',
        name: 'refusePlantJianKong',
        component: () => import('../views/refusePlant/refusePlantJianKong'),
    },
    {// 轨迹追踪
        path: 'refusePlantShuiZhi',
        name: 'refusePlantShuiZhi',
        component: () => import('../views/refusePlant/refusePlantShuiZhi'),
    },
    {// 污水处理
        path: 'refusePlantWuShui',
        name: 'refusePlantWuShui',
        component: () => import('../views/refusePlant/refusePlantWuShui'),
    },
    //垃圾亭管理 -- 基础管理
    {// 位置查询
        path: 'rubbishBasicsWeiZhi',
        name: 'rubbishBasicsWeiZhi',
        component: () => import('../views/rubbishKiosk/basics/rubbishBasicsWeiZhi'),
    },
    {// 载重查询
        path: 'rubbishBasicsYiZhong',
        name: 'rubbishBasicsYiZhong',
        component: () => import('../views/rubbishKiosk/basics/rubbishBasicsYiZhong'),
    },
    {// 溢满查询
        path: 'rubbishBasicsYiMan',
        name: 'rubbishBasicsYiMan',
        component: () => import('../views/rubbishKiosk/basics/rubbishBasicsYiMan'),
    }, {// 投递记录
        path: 'rubbishBasicsjilu',
        name: 'rubbishBasicsjilu',
        component: () => import('../views/rubbishKiosk/basics/rubbishBasicsjilu'),
    },
    //垃圾亭管理 -- 视频管理
    {// 监控视频
        path: 'rubbishVideoJianKong',
        name: 'rubbishVideoJianKong',
        component: () => import('../views/rubbishKiosk/video/rubbishVideoJianKong'),
    }, {// 视频回放
        path: 'playback',
        name: 'playback',
        component: () => import('../views/rubbishKiosk/video/playback'),
    },
    {// 其他垃圾桶管理
        path: 'ashBin',
        name: 'ashBin',
        component: () => import('../views/facility/ashBin'),
    },
    {// 照片管理
        path: 'rubbishVideoZhaoPian',
        name: 'rubbishVideoZhaoPian',
        component: () => import('../views/rubbishKiosk/video/rubbishVideoZhaoPian'),
    },
    //垃圾亭管理 -- 语音管理
    {// 操作指引
        path: 'rubbishVoiceCaoZuo',
        name: 'rubbishVoiceCaoZuo',
        component: () => import('../views/rubbishKiosk/voice/rubbishVoiceCaoZuo'),
    },
    {// 环境监测
        path: 'rubbishVoiceHuanJing',
        name: 'rubbishVoiceHuanJing',
        component: () => import('../views/rubbishKiosk/voice/rubbishVoiceHuanJing'),
    },
    {// ai对话
        path: 'rubbishVoiceAI',
        name: 'rubbishVoiceAI',
        component: () => import('../views/rubbishKiosk/voice/rubbishVoiceAI'),
    },
    {// 远程对话
        path: 'rubbishVoiceYuanCheng',
        name: 'rubbishVoiceYuanCheng',
        component: () => import('../views/rubbishKiosk/voice/rubbishVoiceYuanCheng'),
    },
    {// 有害气体检测
        path: 'rubbishVoiceYouHai',
        name: 'rubbishVoiceYouHai',
        component: () => import('../views/rubbishKiosk/voice/rubbishVoiceYouHai'),
    },
    {// 意见反馈
        path: 'rubbishVoiceYiJian',
        name: 'rubbishVoiceYiJian',
        component: () => import('../views/rubbishKiosk/voice/rubbishVoiceYiJian'),
    },
    //设置
    {// 车辆安全设置
        path: 'setCar',
        name: 'setCar',
        component: () => import('../views/set/setCar'),
    },
    {// 垃圾部门设置
        path: 'setGarbage',
        name: 'setGarbage',
        component: () => import('../views/set/setGarbage'),
    },

    {// 系统消息设置
        path: 'setNews',
        name: 'setNews',
        component: () => import('../views/set/setNews'),
    },
    {// 人员安全设置
        path: 'setPeople',
        name: 'setPeople',
        component: () => import('../views/set/setPeople'),
    },
    {// 音量设置
        path: 'setVolume',
        name: 'setVolume',
        component: () => import('../views/set/setVolume'),
    },
    {// 积分规则设置
        path: 'setTotal',
        name: 'setTotal',
        component: () => import('../views/set/setTotal'),
    },
    //设备管理
    {// 用户管理
        path: 'facilityUser',
        name: 'facilityUser',
        component: () => import('../views/facility/facilityUser'),
    },
    {// 商品管理
        path: 'facilityShop',
        name: 'facilityShop',
        component: () => import('../views/facility/facilityShop'),
    }, {// 消息管理
        path: 'facilityXiaoXI',
        name: 'facilityXiaoXI',
        component: () => import('../views/facility/facilityXiaoXI'),
    }, {// 手环管理
        path: 'facilityxiongka',
        name: 'facilityxiongka',
        component: () => import('../views/facility/facilityxiongka'),
    }, {// 车辆管理
        path: 'facilityCar',
        name: 'facilityCar',
        component: () => import('../views/facility/facilityCar'),
    }, {// 摄像头管理
        path: 'facilityCamera',
        name: 'facilityCamera',
        component: () => import('../views/facility/facilityCamera'),
    },
    {// 小区管理
        path: 'facilityPlot',
        name: 'facilityPlot',
        component: () => import('../views/facility/facilityPlot'),
    },
    {// 垃圾桶管理
        path: 'facilityGarbage',
        name: 'facilityGarbage',
        component: () => import('../views/facility/facilityGarbage'),
    },
    {// 垃圾亭管理
        path: 'facilityGarbageKiosk',
        name: 'facilityGarbageKiosk',
        component: () => import('../views/facility/facilityGarbageKiosk'),
    },
    {// 其他设备管理
        path: 'facilityElse',
        name: 'facilityElse',
        component: () => import('../views/facility/facilityElse'),
    },
    //统计报表--常用报表
    {// 里程报表
        path: 'tableUseLiCheng',
        name: 'tableUseLiCheng',
        component: () => import('../views/table/user/tableUseLiCheng'),
    },
    {// IC卡报表
        path: 'tableUseIC',
        name: 'tableUseIC',
        component: () => import('../views/table/user/tableUseIC'),
    },
    {// 考勤报表
        path: 'tableUseKaoQin',
        name: 'tableUseKaoQin',
        component: () => import('../views/table/user/tableUseKaoQin'),
    },
    {// 轨迹报表
        path: 'tableUseGuiJi',
        name: 'tableUseGuiJi',
        component: () => import('../views/table/user/tableUseGuiJi'),
    },
    {// 位置报表
        path: 'tableUseWeiZhi',
        name: 'tableUseWeiZhi',
        component: () => import('../views/table/onLine/tableUseWeiZhi'),
    },
    {// 指令报表
        path: 'tableUseZhiLing',
        name: 'tableUseZhiLing',
        component: () => import('../views/table/user/tableUseZhiLing'),
    },
    //统计报表--洒水报表
    {// 洒水统计
        path: 'tablePurlingTongJi',
        name: 'tablePurlingTongJi',
        component: () => import('../views/table/purling/tablePurlingTongJi'),
    },
    {// 洒水年月日报表
        path: 'tablePurlingNYR',
        name: 'tablePurlingNYR',
        component: () => import('../views/table/purling/tablePurlingNYR'),
    },
    //统计报表--报警报表
    {// 超速报警报表
        path: 'tableAlterOver',
        name: 'tableAlterOver',
        component: () => import('../views/table/alter/tableAlterOver'),
    },
    {// 疲劳驾驶报警报表
        path: 'tableAlterFatigue',
        name: 'tableAlterFatigue',
        component: () => import('../views/table/alter/tableAlterFatigue'),
    },
    //统计报表--污水报表
    {// 污水统计
        path: 'tableSewageTongJi',
        name: 'tableSewageTongJi',
        component: () => import('../views/table/sewage/tableSewageTongJi'),
    },
    {// 气味统计
        path: 'tableSewageGas',
        name: 'tableSewageGas',
        component: () => import('../views/table/sewage/tableSewageGas'),
    },
    {// 水质统计
        path: 'tableSewageWater',
        name: 'tableSewageWater',
        component: () => import('../views/table/sewage/tableSewageWater'),
    },
    //统计报表--垃圾桶报表
    {// 垃圾桶重量统计
        path: 'tableGarbageiTongJi',
        name: 'tableGarbageiTongJi',
        component: () => import('../views/table/garbagei/tableGarbageiTongJi'),
    },
    {// 垃圾桶重量报表
        path: 'tableGarbageiBaoBiao',
        name: 'tableGarbageiBaoBiao',
        component: () => import('../views/table/garbagei/tableGarbageiBaoBiao'),
    },
    //统计报表--上线报表
    {// 在线率报表
        path: 'tableOnLineZaiXian',
        name: 'tableOnLineZaiXian',
        component: () => import('../views/table/onLine/tableOnLineZaiXian'),
    },
    {// 车辆掉线报表
        path: 'tableOnLineCarLost',
        name: 'tableOnLineCarLost',
        component: () => import('../views/table/onLine/tableOnLineCarLost'),
    },
    {// 车辆离线报表
        path: 'tableOnLineCarOff',
        name: 'tableOnLineCarOff',
        component: () => import('../views/table/onLine/tableOnLineCarOff'),
    },
    {// 车辆上线报表
        path: 'tableOnLineCarUp',
        name: 'tableOnLineCarUp',
        component: () => import('../views/table/onLine/tableOnLineCarUp'),
    },
    //统计报表--载重报表
    {// 车辆调度报表
        path: 'tableLoadCarDiaoDu',
        name: 'tableLoadCarDiaoDu',
        component: () => import('../views/table/load/tableLoadCarDiaoDu'),
    },
    {// 载重统计
        path: 'tableLoadTongJi',
        name: 'tableLoadTongJi',
        component: () => import('../views/table/load/tableLoadTongJi'),
    },
    {// 载重年月日报表
        path: 'tableLoadNYR',
        name: 'tableLoadNYR',
        component: () => import('../views/table/load/tableLoadNYR'),
    },
    //统计报表--APP报表
    {// 垃圾投放占比统计
        path: 'tableAPPGarbegei',
        name: 'tableAPPGarbegei',
        component: () => import('../views/table/APP/tableAPPGarbegei'),
    },
    {// 积分发放统计
        path: 'tableAPPTotalGive',
        name: 'tableAPPTotalGive',
        component: () => import('../views/table/APP/tableAPPTotalGive'),
    },
    {// 积分消费统计
        path: 'tableAPPTotalShop',
        name: 'tableAPPTotalShop',
        component: () => import('../views/table/APP/tableAPPTotalShop'),
    },
    {// 积分兑换记录
        path: 'tableAPPTotalConvert',
        name: 'tableAPPTotalConvert',
        component: () => import('../views/table/APP/tableAPPTotalConvert'),
    },
    //统计报表--油耗报表
    {// 油耗统计
        path: 'tableOilTongJi',
        name: 'tableOilTongJi',
        component: () => import('../views/table/oil/tableOilTongJi'),
    },
    {// 油耗年月日报表
        path: 'tableOilNYR',
        name: 'tableOilNYR',
        component: () => import('../views/table/oil/tableOilNYR'),
    }, {// 油耗年月日报表
        path: 'tableOilAdd',
        name: 'tableOilAdd',
        component: () => import('../views/table/oil/tableOilAdd'),
    },
    //统计报表--小程序报表
    {// 垃圾投放占比统计
        path: 'tableAppletGarbegei',
        name: 'tableAppletGarbegei',
        component: () => import('../views/table/Applet/tableAppletGarbegei'),
    },
    {// 积分发放统计
        path: 'tableAppleTotalGive',
        name: 'tableAppleTotalGive',
        component: () => import('../views/table/Applet/tableAppleTotalGive'),
    },
    {// 积分消费统计
        path: 'tableAppletTotalShop',
        name: 'tableAppletTotalShop',
        component: () => import('../views/table/Applet/tableAppletTotalShop'),
    },
    {// 积分兑换记录
        path: 'tableAppletTotalConvert',
        name: 'tableAppletTotalConvert',
        component: () => import('../views/table/Applet/tableAppletTotalConvert'),
    },
    {// 积分排行榜
        path: 'tableAppletTotalList',
        name: 'tableAppletTotalList',
        component: () => import('../views/table/Applet/tableAppletTotalList'),
    },




]